import { User } from '@/types/user';

export const useSubscription = (user: User | null) => {
  const hasActiveSubscription = () => {
    const now = new Date();

    const activeSubscriptions = user?.subscriptions?.filter(
      subscription =>
        subscription.stripe_status === 'active' ||
        (subscription.stripe_status === 'trialing' &&
          subscription.trial_ends_at &&
          new Date(subscription.trial_ends_at) > now),
    );

    const activeSeats =
      user?.seats?.filter(
        seat =>
          seat.is_active === 1 &&
          (seat.stripe_status === 'active' ||
            (seat.stripe_status === 'trialing' &&
              seat.trial_ends_at &&
              new Date(seat.trial_ends_at) > now)),
      )?.length || 0;

    return !!activeSubscriptions?.length || activeSeats > 0;
  };

  const hasSubscription = (type: string) => {
    const subscription = user?.subscriptions?.find(
      subscription => subscription.type === type,
    );
    const seat = user?.seats?.find(seat => seat.type === type);
    return !!subscription || !!seat;
  };

  return { hasActiveSubscription, hasSubscription };
};
